import { createAction, props } from '@ngrx/store';

import {
  DisconnectReason,
  IdentifyFailureReason,
} from '@app/core/realtime/realtime.types';

export type LogoutSource = 'user' | 'interceptor' | 'realtime';

export type ForceLogoutReason = DisconnectReason | IdentifyFailureReason;

/**
 * Centralized logout action. The matching effect tears down the WebSocket,
 * optionally calls the backend logout endpoint (only when initiated by the
 * user — interceptor and realtime paths are already in a failed state), clears
 * token storage and routes to `/auth/login`. Use this anywhere logout would
 * otherwise be performed imperatively.
 */
export const logout = createAction(
  '[Auth] Logout',
  props<{ source: LogoutSource }>()
);

export const logoutSuccess = createAction('[Auth] Logout Success');
export const logoutFailure = createAction(
  '[Auth] Logout Failure',
  props<{ error: unknown }>()
);

/**
 * Force-logout fired by the realtime pipeline (session revoked, password
 * changed, kicked, etc.) and by the auth interceptor when token refresh is
 * impossible. Carries a reason so the matching effect can show a localized
 * toast (key `realtime.forceLogout.<reason>`).
 */
export const forceLogout = createAction(
  '[Auth] Force Logout',
  props<{ reason: ForceLogoutReason }>()
);
